module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/SanGabriels2_BW-p-500-285a83683114a447929a8c2973acb89c.jpg";